import qs from 'qs';
import { keyBy, orderBy } from 'lodash';
import callApi from '../../util/apiCaller';
// Export Constants
export const TEAMS_FETCH_ALL_TEAMS = 'TEAMS_FETCH_ALL_TEAMS';
export const TEAMS_CREATE_TEAM = 'TEAMS_CREATE_TEAM';
export const TEAMS_UPDATE_TEAM = 'TEAMS_UPDATE_TEAM';
export const TEAMS_DELETE_TEAM = 'TEAMS_DELETE_TEAM';
export const TEAMS_VIEW_TEAM = 'TEAMS_VIEW_TEAM';
export const TEAMS_FETCH_ALL_MEMBERS = 'TEAMS_FETCH_ALL_MEMBERS';
export const TEAMS_FETCH_TEAM_TREE = 'TEAMS_FETCH_TEAM_TREE';

export function fetchAllTeams() {
  const empty = {
    teams: [],
    owners: {},
    status: null,
    errors: null,
  };
  return (dispatch) => {
    dispatch({
      type: TEAMS_FETCH_ALL_TEAMS,
      ...empty,
      status: 'loading',
      errors: null,
    });

    const p = callApi('teams', 'GET');
    p.then(
      ({ teams, owners }) => {
        return dispatch({
          type: TEAMS_FETCH_ALL_TEAMS,
          ...empty,
          status: 'loaded',
          errors: null,
          teams,
          owners: keyBy(owners, 'user_id'),
        });
      },
      (errors) => {
        return dispatch({
          type: TEAMS_FETCH_ALL_TEAMS,
          ...empty,
          status: 'error',
          errors,
        });
      },
    );
    return p;
  };
}

export function resetTeamTree(loaded = false) {
  const empty = {
    teams: [],
    owners: {},
    status: null,
    errors: null,
  };
  return (dispatch) => {
    dispatch({
      type: TEAMS_FETCH_TEAM_TREE,
      ...empty,
      status: loaded ? 'loaded' : 'loading',
      errors: null,
    });
    dispatch({
      type: TEAMS_FETCH_ALL_MEMBERS,
      status: null,
      errors: null,
      owners: {},
    });
    return Promise.resolve();
  };
}

function clearTeamTree(dispatch) {
  const empty = {
    teams: [],
    owners: {},
    status: null,
    errors: null,
  };
  return dispatch({
    type: TEAMS_FETCH_TEAM_TREE,
    ...empty,
  });
}

export function resetAll() {
  return (dispatch) => {
    dispatch({
      type: TEAMS_FETCH_ALL_TEAMS,
      status: null,
      errors: null,
      teams: [],
      owners: {},
    });
    clearTeamTree(dispatch);
    return Promise.resolve(true);
  };
}

export function createTeam(params) {
  return (dispatch) => {
    const p = callApi('teams', 'POST', params);
    p.then(
      ({ team }) => {
        clearTeamTree(dispatch);
        return dispatch({
          type: TEAMS_CREATE_TEAM,
          team,
        });
      },
      () => {},
    );
    return p;
  };
}

export function updateTeam(id, params) {
  return (dispatch) => {
    const p = callApi(`teams/${id}`, 'PUT', params);
    p.then(
      ({ team }) => {
        clearTeamTree(dispatch);
        return dispatch({
          type: TEAMS_UPDATE_TEAM,
          team,
        });
      },
      () => {},
    );
    return p;
  };
}

export function deleteTeam(id) {
  return (dispatch) => {
    const p = callApi(`teams/${id}`, 'DELETE');
    p.then(
      () => {
        clearTeamTree(dispatch);
        return dispatch({
          type: TEAMS_DELETE_TEAM,
          id,
        });
      },
      () => {},
    );
    return p;
  };
}

export function viewTeam(id) {
  return (dispatch) => {
    const p = callApi(`teams/${id}`, 'GET');
    p.then(
      ({ team, owners }) =>
        dispatch({
          type: TEAMS_VIEW_TEAM,
          team,
          owners: keyBy(owners, 'user_id'),
        }),
      () => {},
    );
    return p;
  };
}

export function assignMember(id, params, query) {
  return (dispatch) => {
    const q = qs.stringify(query)
    const p = callApi(`teams/${id}/members?${q}`, 'POST', params);
    p.then(
      ({ team, owners }) => {
        if (!query.countOnly) {
          clearTeamTree(dispatch);
          dispatch({
            type: TEAMS_VIEW_TEAM,
            team,
            owners: keyBy(owners, 'user_id'),
          });
        }
      },
      () => {},
    );
    return p;
  };
}

export function massAssignMember(id, params) {
  return (dispatch) => {
    const p = callApi(`teams/${id}/members`, 'PUT', params);
    p.then(
      ({ team, owners }) => {
        clearTeamTree(dispatch);
        dispatch({
          type: TEAMS_VIEW_TEAM,
          team,
          owners: keyBy(owners, 'user_id'),
        });
      },
      () => {},
    );
    return p;
  };
}

export function updateMember(id, ownerId, params) {
  return (dispatch) => {
    const p = callApi(`teams/${id}/members/${ownerId}`, 'PUT', params);
    p.then(
      ({ team, owners }) => {
        clearTeamTree(dispatch);
        dispatch({
          type: TEAMS_VIEW_TEAM,
          team,
          owners: keyBy(owners, 'user_id'),
        });
      },
      () => {},
    );
    return p;
  };
}

export function deleteMember(id, ownerId) {
  return (dispatch) => {
    const p = callApi(`teams/${id}/members/${ownerId}`, 'DELETE');
    p.then(
      ({ team, owners }) => {
        clearTeamTree(dispatch);
        dispatch({
          type: TEAMS_VIEW_TEAM,
          team,
          owners: keyBy(owners, 'user_id'),
        });
      },
      () => {},
    );
    return p;
  };
}

// available memebers
export function fetchAvailableMembers(teamId, params = {}) {
  const empty = {
    owners: {},
    status: null,
    errors: null,
  };
  return (dispatch) => {
    dispatch({
      type: TEAMS_FETCH_ALL_MEMBERS,
      ...empty,
      status: 'loading',
      errors: null,
    });
    const p = callApi(`teams/${teamId}/available-members`, 'GET', params);
    p.then(
      ({ users }) => {
        return dispatch({
          type: TEAMS_FETCH_ALL_MEMBERS,
          ...empty,
          status: 'loaded',
          errors: null,
          users: { users },
        });
      },
      (errors) => {
        return dispatch({
          type: TEAMS_FETCH_ALL_MEMBERS,
          ...empty,
          status: 'error',
          errors,
        });
      },
    );
    return p;
  };
}

export function fetchTeamTree() {
  const empty = {
    teams: [],
    owners: {},
    status: null,
    errors: null,
  };
  return (dispatch) => {
    dispatch({
      type: TEAMS_FETCH_TEAM_TREE,
      ...empty,
      status: 'loading',
      errors: null,
    });

    const p = callApi('teams/tree', 'GET');
    p.then(
      ({ teams, owners }) => {
        return dispatch({
          type: TEAMS_FETCH_TEAM_TREE,
          ...empty,
          status: 'loaded',
          errors: null,
          teams: orderBy(teams, { is_default: -1 }),
          owners,
        });
      },
      (errors) => {
        return dispatch({
          type: TEAMS_FETCH_TEAM_TREE,
          ...empty,
          status: 'error',
          errors,
        });
      },
    );
    return p;
  };
}

export function fetchManagers(q) {
  return () => {
    const p = callApi('teams/managers', 'GET', { q });
    return p;
  };
}

export function cloneTeam(id, userIds, name) {
  return () => {
    const p = callApi(`teams/${id}/clone`, 'POST', { user_ids: userIds, name });
    return p;
  };
}
